import React from 'react';
import './style.css'

const BlogPosts = () => {
  return (
    <section className='posts'>
      <a href='https://blog.naver.com/testworks_mktg' className='blog-post'>
        <div className='inner'>
          <div className='blog-wrap'>
            <div>최신 블로그 게시물을 확인해보세요</div>
            <div className='blog-icons'>
              <div className='blog-icon1'></div>
              <div className='blog-icon2'></div>
            </div>
          </div>
        </div>
      </a>
      <div className='sns-post'>
        <div className='inner'>
          <div className='sns-wrap'>
            <div className='sns-title'>SNS를 통해 에이아이웍스의 최신 소식을 확인해 보세요!</div>
            <div className='sns-logos'>
              <a href='https://www.facebook.com/aiworkxkorea' className='logo' >
                <div className='f-logo'></div>
                <span className='logo-icon'></span>
              </a>
              <a href='https://www.youtube.com/channel/UCqzPNUMb4eSlewvRY87LqNA' className='logo'>
                <span className='y-logo'></span>
                <span className='logo-icon'></span>
              </a>
              <a href='https://www.linkedin.com/company/testworks-inc/' className='logo'>
                <span className='i-logo'></span>
                <span className='logo-icon'></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

  )
}

export default BlogPosts;